import React, { useState, useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import countries from "../pages/Countries";
import "../pages/Contact.css";

export default function Contact() {
  const [search, setSearch] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [result, setResult] = useState("");

  const location = useLocation();

  // Get role from router state or querystring
  const roleFromState = location.state?.role;
  const roleFromQuery = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("role");
  }, [location.search]);
  const role = roleFromState || roleFromQuery || "";

  // Prefill message if role is present
  const [message, setMessage] = useState(
    role
      ? `Hello Team Maya Exports Ltd,\n\nI would like to apply for the "${role}" position. Please find my details below:\n\n- Name:\n- Experience:\n- Portfolio/Resume link:\n\nRegards,\n`
      : ""
  );

  useEffect(() => {
    if (role) {
      setMessage(
        `Hello Team Maya Exports Ltd,\n\nI would like to apply for the "${role}" position. Please find my details below:\n\n- Name:\n- Experience:\n- Portfolio/Resume link:\n\nRegards,\n`
      );
    }
  }, [role]);

  const filteredCountries = countries.filter((country) =>
    country.toLowerCase().includes(search.toLowerCase())
  );

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");
    const formData = new FormData(event.target);

    // Add your Web3Forms Access Key
    formData.append("access_key", "c235137d-5f1b-4e19-b18f-d996620e87ba");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully ✅");
      event.target.reset();
      setSearch("");
      setSelectedCountry("");
      setMessage(""); // clear message
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <div className="contact-page">
      <form className="contact-form" onSubmit={onSubmit}>
        <h1>Contact Us</h1>

        <input type="text" name="name" placeholder="Your name*" required />
        <input type="text" name="company" placeholder="Company Name" />
        <input type="email" name="email" placeholder="Your email*" required />
        <input type="text" name="phone" placeholder="Contact Number*" required />

        {/* Searchable Country Dropdown */}
        <div className="dropdown">
          <input
            type="text"
            placeholder="Search Country*"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            required
          />
          <ul className="dropdown-list">
            {filteredCountries.map((country, index) => (
              <li
                key={index}
                onClick={() => {
                  setSelectedCountry(country);
                  setSearch(country);
                }}
              >
                {country}
              </li>
            ))}
          </ul>
        </div>

        {/* Hidden field to actually send selected country */}
        <input type="hidden" name="country" value={selectedCountry} />

        {/* Prefilled Message */}
        <textarea
          name="message"
          placeholder="Your message"
          rows="6"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <button type="submit">Send Message</button>
        <span className="form-result">{result}</span>
      </form>
    </div>
  );
}
